// NOTE: This component is intentionally inert. The descriptor update logic now lives in
// product-card.js (see ibdUpdateDescriptor) for cards, and on the product page the descriptor
// is updated via the morphed section markup. Kept as a placeholder custom element registration.

/**
 * A custom element that displays a product title.
 * This component listens for variant update events and updates the descriptor display accordingly.
 * It handles descriptor updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 *
 * ? NOTE: This class was created to update the descriptor in the IBD Product Title component.
 * ? However, we moved the update logic to the product-card.js file – see the ibdUpdateDescriptor() method.
 * ? We're keeping this class around for now for the knowledge of how to listen for variant update events,
 * ? which could be useful for the ibd-purchase-type-selector component.
 *
 */
class IbdProductTitle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // const target = this.closest('.shopify-section, dialog, product-card');
    // target?.addEventListener(ThemeEvents.variantUpdate, this.updateDescriptor.bind(this));
  }

  disconnectedCallback() {
    // const target = this.closest('.shopify-section, dialog, product-card');
    // target?.removeEventListener(ThemeEvents.variantUpdate, this.updateDescriptor);
  }

  /**
   * Updates the descriptor.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  /*
  updateDescriptor(event) {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }
    const newDescriptor = event.detail.data.html.querySelector('ibd-product-title [ref="descriptorContainer"]');
    const currentDescriptor = this.querySelector('[ref="descriptorContainer"]');
    if (!newDescriptor || !currentDescriptor) return;
    if (currentDescriptor.innerHTML !== newDescriptor.innerHTML) {
      currentDescriptor.replaceWith(newDescriptor);
    }
  }
  */
}

if (!customElements.get('ibd-product-title')) {
  customElements.define('ibd-product-title', IbdProductTitle);
}
